"use client"

import { Skeleton } from "antd"
import { SkeletonImageProps } from "antd/es/skeleton/Image"

const SkeletonImage = (props: SkeletonImageProps) => {
  return <Skeleton.Image {...props} />
}

export default SkeletonImage